export interface Cotizacion {
  idCotizacion: number;
  idPersona: number | null;
  idVendedor: number | null;
  idMoneda: number | null;
  idListaPrecio: number | null;
  numero: string | null;
  fechaCotizacion: string;
  fechaValidez: string | null;
  estado: string | null;
  observaciones: string | null;
  subTotal: number;
  totalIGV: number;
  totalDescuento: number;
  total: number;
  persona: any | null;
  vendedor: any | null;
  moneda: any | null;
  detalles: CotizacionDetalle[];
}

export interface CotizacionDetalle {
  idCotizacionDetalle: number;
  idCotizacion: number;
  idArticulo: number | null;
  descripcion: string | null;
  unidadMedida: string | null;
  cantidad: number;
  precioUnitario: number;
  descuento: number;
  subTotal: number;
  igv: number;
  total: number;
}

export interface CotizacionCreateRequest {
  idPersona: number;
  idVendedor?: number | null;
  idMoneda?: number | null;
  idListaPrecio?: number | null;
  numero?: string | null;
  fechaValidez?: string | null;
  observaciones?: string | null;
  detalles: CotizacionDetalleRequest[];
}

export interface CotizacionDetalleRequest {
  idArticulo: number;
  descripcion: string;
  unidadMedida?: string | null;
  cantidad: number;
  precioUnitario: number;
  descuento?: number;
}

export interface CotizacionFormErrors {
  idPersona?: string;
  detalles?: string;
}

export const initialCotizacionCreate: CotizacionCreateRequest = {
  idPersona: 0,
  detalles: [],
};
